<template>
    <header class="card-header" @click="goToLotSinglePage(bid.lot_id)">
        <p class="card-header-title">
            <img :src="'/static/images/manufacturers/' +  bid.company + '.png'" style="float: left; margin-right: 10px;" width="50">
            <strong class="has-text-primary" style="padding-right: 5px;">{{ bid.company }}</strong>
            <strong style="padding-right: 5px;">{{ bid.model_name }}</strong>
            <strong v-if="!isMobile" style="padding-right: 5px;">{{ bid.auction_name }}</strong>
            <strong v-if="!isMobile" style="padding-right: 5px;">@{{ bid.lot_date }}</strong>
        </p>
        <p class="card-header-icon title is-2" style="margin-bottom: 0px;">
            <span style="margin-right: 10px;" class="has-text-danger">{{ bid.scores }}</span>
            <img :src="'/static/images/auctions/' + bid.auction_name  + '.png'"
                 @error="getDefaultImgSource" style="max-height: 30px; padding-right: 15px;"
                 class="is-hidden-touch">
        </p>
        <div class="card-image is-hidden-desktop">
            <figure class="image is-4by3">
                <img :src="bid.pictures.split('#')[1] + '&w=320'">
            </figure>
        </div>
    </header>
</template>

<script>
    export default {
        props: ['bid'],
        methods: {
            getDefaultImgSource(element) {
                element.target.src = '/static/images/logo.png'
            },
            goToLotSinglePage(id) {
                this.$router.push({
                    path: '/single/' + id,
                })
            }
        },
        computed: {
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        }
    }
</script>

<style scoped>
    .card-header:hover {
        cursor: pointer;
    }
    .card-header-title {
        padding-bottom: 0px;
        padding-top: 0px;
    }
    .card-header-icon {
        padding-bottom: 0px;
        padding-top: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Card/Headers/LotHeader.vue